<script setup lang="ts">
  defineProps<{ blok: any }>()

  const { isDesktopLarge, isDesktopSmall, isTablet } = useBTBreakpoints()

  const imageWidth = computed(() => {
    if (isDesktopLarge.value) {
      return 1416
    }

    if (isDesktopSmall.value) {
      return 1128
    }

    if (isTablet.value) {
      return 1024
    }

    return 768
  })

  const imageHeight = computed(() => {
    if (isDesktopLarge.value) {
      return 480
    }

    if (isDesktopSmall.value) {
      return 400
    }

    if (isTablet.value) {
      return 360
    }

    return 240
  })
</script>

<template>
  <div
    v-editable="blok"
    class="h-60 w-full overflow-hidden md:container md:mx-auto md:mt-10 md:h-90 lg:h-100 xl:h-120"
    :style="{ height: `${imageHeight}px` }"
  >
    <NuxtImg
      v-if="blok.hero.filename"
      provider="storyblok"
      class="h-full w-full object-cover md:rounded-md"
      :title="blok.hero.title"
      :src="blok.hero.filename"
      :alt="blok.hero.alt"
      :width="imageWidth"
      :height="imageHeight"
      :modifiers="{ filters: { focal: blok.hero?.focus }, smart: true }"
    />
  </div>
</template>
